import React from 'react';

class Start extends React.Component {
    render() {
	return (
	    <div className="content">
		<h2>Varen h&auml;lsad &Auml;fventyrsm&auml;stare!</h2>

		<p>
		    Du har nu tr&auml;tt in i m&auml;starnas dom&auml;ner.
		</p>

		<p>
		    H&auml;r p&aring; &Auml;K Alumni kan du hitta alla de &auml;ventyr som skapats under &aring;ren, s&aring;v&auml;l av kursdeltagarna som kursteamet. Du som gick &Auml;ventyrskursen f&ouml;r m&aring;nga &aring;r sedan kommer att hitta m&aring;nga nya &auml;ventyr h&auml;r som inte fanns med p&aring; den CD  (eller papper om du gick f&ouml;r RIKTIGT l&auml;nge sedan) som du en g&aring;ng fick ut efter kursen.
		</p>

		<p>
		    H&auml;r finns ocks&aring; en lista p&aring; alla &Auml;K Alumni som har konto p&aring; sajten. Anv&auml;nd den f&ouml;r att h&aring;lla kontakt och utbyta &auml;ventyrsid&eacute;er.
		</p>

		<p>
		    Alumni &auml;r beteckningen p&aring; utexaminerade f.d. studenter i en utbildning, oftast fr&aring;n ett universitet. En Alumni-f&ouml;rening finns f&ouml;r att hj&auml;lpa gamla studiekamrater att h&aring;lla kontakten, och f&ouml;r att uppr&auml;tth&aring;lla n&auml;tverk till &ouml;msesidig nytta och n&ouml;je.
		</p>

		<p>
		    Ditt l&ouml;senord &auml;r personligt och f&aring;r inte l&auml;mnas ut till n&aring;gon annan. Du har givetvis r&auml;tt att anv&auml;nda &auml;ventyren och materialet h&auml;r som inspiration (eller plagiera!) till dina egna &auml;ventyr. Du f&aring;r dock inte utan &Auml;ventyrskursens tillst&aring;nd kopiera eller l&auml;mna vidare materialet i n&aring;gon form till utomst&aring;ende.  
		</p>

		<br/>

		<p>
		    &Aring;terigen, v&auml;lkommen!<br/>
		    <i>Kursteamet &Auml;ventyrskursen</i>
		</p>
	    </div>
	);
    }
}

export default Start;
